<div>
    <p-tabMenu #tabMenu [model]="items" [activeItem]="activeItem" (click)="onTabMenClicked()"></p-tabMenu>
</div>
<form
    (ngSubmit)="onSearchClicked($event)"
    #searchForm="ngForm"
    [ngStyle]="{
        'pointer-events': enableSearch ? '' : 'none',
        'opacity': enableSearch ? '1' : '0.6'
    }">
    <section id="searchByKeyword" class="mt-5" *ngIf="activeItem.label === 'Search by Keyword'">
        <div class="card p-fluid">
            <div class="grid">
                <div class="col-12 p-formgrid">
                    <div class="grid">
                        <div class="field col-12 md:col-3">
                            <label htmlFor="keyword-input">Keyword</label>
                            <input id="keyword-input" pInputText [(ngModel)]="keyword" name="keyword" type="text" required/>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="location-dropdown">Location</label>
                            <p-dropdown id="location-dropdown" [options]="locationOptions" name="location" optionLabel="locationName" [(ngModel)]="selectedLocation" (onChange)="onLocationChange($event)"></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="language-dropdown">Language</label>
                            <p-dropdown id="language-dropdown" [options]="languageOptions" name="label" optionLabel="languageName" [(ngModel)]="selectedLanguage"></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-3">
                            <button id="keyword-search-btn" class="search-btn" pButton type="submit" [disabled]="!searchForm.form.valid || this.cache.loading" label="Search">
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <gig-advance-filter
                        [ruleset]="ruleset"
                        [qbConfig]="qbConfig"
                        [qbProcessor]="qbProcessor"
                        (advanceFilterEvent)="onAdvanceFilterChange($event)"
                        [hidden]="isNotAdvanceSearch"
                    ></gig-advance-filter>
                    <!-- <p-dropdown class="search-menu-options absolute" [options]="searchMenuOptions" name="searchMenuOptions" optionLabel="name" [(ngModel)]="selectedSearchMenuOption"></p-dropdown> -->
                </div>
                <div class="w-full xl:w-5">
                    <p-selectButton
                        id="search-menu-options-btn"
                        [hidden]="isNeed"
                        [options]="searchMenuOptions"
                        [(ngModel)]="selectedSearchMenuOption"
                        optionLabel="name"
                        (onOptionClick)="onSearchMenuOptionClicked($event)"
                        name="searchMenuOptions">
                        <ng-template let-item pTemplate>
                            <span [id]="item.name.toLowerCase().replace(' ', '-')">{{item.name}}</span>
                        </ng-template>
                    </p-selectButton>
                </div>
            </div>
        </div>
    </section>
    <section id="searchByDomain" class="mt-5" *ngIf="activeItem.label === 'Search by Domain'">
        <div class="card p-fluid">
            <div class="p-formgrid grid">
                <div class="field col-12 md:col-4">
                    <label htmlFor="domain-input">Domain</label>
                    <input id="domain-input" class="p-inputtext p-component p-element" pInputText [(ngModel)]="domain" name="domain" type="text" required/>
                </div>
                <div class="field col-12 md:col-3">
                    <label htmlFor="domain-location-dropdown">Location</label>
                    <p-dropdown id="domain-location-dropdown" [options]="locationOptions" name="location" optionLabel="locationName" [(ngModel)]="selectedLocation" (onChange)="onLocationChange($event)"></p-dropdown>
                </div>
                <div class="field col-12 md:col-3">
                    <label htmlFor="domain-language-dropdown">Language</label>
                    <p-dropdown id="domain-language-dropdown" [options]="languageOptions" name="language" optionLabel="languageName" [(ngModel)]="selectedLanguage"></p-dropdown>
                </div>
                <div class="field col-12 md:col-2">
                    <button id="domain-search-btn" class="p-element p-button p-component mt-5" pButton type="submit" [disabled]="!searchForm.form.valid" label="Search">
                    </button>
                </div>
            </div>
            <!-- Ranked Keywords needs a dedicated filter schema before filtering can be offered here. -->
        </div>
    </section>
</form>
